module.exports = __webpack_public_path__ + "img/0Q3B3199_L_BlackMatted_MockedUp.ffb67c61.jpg";